import React from 'react'
import ReactDOM from 'react-dom'
import {BrowserRouter} from "react-router-dom"
import {Provider} from 'react-redux'
import {store} from './redux/store'
import AppContext from './AppContext'
import Auth from './components/Auth'
import Header from './components/Header'
import Footer from './components/Footer'
import './assets/styles/index.scss'

localStorage.clear()

ReactDOM.render(
  <Provider store={store}>
    <AppContext/>
  </Provider>,
  document.getElementById('root')
);
